export const ACCOUNT_RETRIEVAL_FAILED = 'There was an error retrieving the account. The request failed.'
export const TEMPORARILY_UNAVAILABLE = 'Sorry, this service is temporarily unavailable. Please check back later.'
export const TRADE_CREATION_FAILURE = 'There was an error submitting your trade. The request failed.'
export const TRADE_SUBMITTED_MESSAGE = 'Your trade has been submitted for processing.'
